export const isStartWithProtocol = (text: string): boolean => {
  const regex = /^(https?:\/\/)/;
  return regex.test(text);
};
